import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { useBaseTable } from 'hooks/useBaseTable';

import { UseReportSettingsModalProvider } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.provider';
import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import { useReportAccessTableLogic } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/SpecificUsersAccess.logic';
import { DebouncedSearchInput } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/components/DebouncedSearchInput/DebouncedSearchInput';
import { UsersAccessTable } from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/components/UsersAccessTable/UsersAccessTable';
import {
    initialState,
    usersAccessTableColumns,
} from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/components/UsersAccessTable/UsersAccessTable.utils';

interface Props {
    api: UseReportSettingsModalProvider['api'];
}

export const SpecificUsersAccess = ({ api }: Props) => {
    // form context
    const { control } = useFormContext<FormValues>();

    const { isLoading, isFetching } = api.getAccessStatus;

    const userList = useWatch({ control, name: 'userAccessList' });

    const { table } = useBaseTable({
        widgetId: undefined,
        localFilters: {},
        componentKey: '',
        initialState,
        columns: usersAccessTableColumns,
    });

    const { logic } = useReportAccessTableLogic({ table, userList: userList ?? [] });

    return (
        <>
            <DebouncedSearchInput onSearch={logic.onTableSearch} />
            <UsersAccessTable userList={userList} isLoading={isLoading} isFetching={isFetching} table={table} />
        </>
    );
};
